import React from 'react';

export default () => {
    return (
        <pui-divider style={{ height: '4px', width: '100vw', position: 'relative', left: '-19px' }} spacingTop="medium" spacingBottom="medium" />
    )
}